import { useEffect, useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { JobPost } from "@/types/jobPost";

interface UseJobPostDetailsOptions {
  jobPostId: JobPost["id"] | undefined;
}

export const useJobPostDetails = ({ jobPostId }: UseJobPostDetailsOptions) => {
  const [jobPost, setJobPost] = useState<JobPost | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (jobPostId === undefined) return;

    const fetchJobPostDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axiosInstance.get<JobPost>(
          `jobs/job_posts/${jobPostId}/`,
        );

        setJobPost(response.data);
      } catch (err: unknown) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchJobPostDetails();
  }, [jobPostId]);

  return {
    jobPost,
    loading,
    error,
  };
};
